/* Nordlys cart complements v2: audited against all 18 Product mega-menu entries. */
(() => {
  'use strict';
  const normalize = v => String(v || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[-_]/g, ' ');
  // The menu collections are the catalog registry. New is cross-category, never a product type.
  const categories = [
    {handle:'nouveautes', label:'New', kinds:[]},
    {handle:'chaises', label:'Chaises', kinds:['dining_chair']},
    {handle:'tables-a-manger', label:'Tables à manger', kinds:['dining_table','bar_table']},
    {handle:'lits', label:'Lits & têtes de lit', kinds:['bed','headboard']},
    {handle:'fauteuils-1', label:'Fauteuils', kinds:['armchair']},
    {handle:'poufs-bancs', label:'Bancs & poufs', kinds:['bench','pouf','stool','shoe_storage']},
    {handle:'tables', label:"Tables basses & tables d'appoint", kinds:['coffee_table','side_table','tv_stand']},
    {handle:'etageres-et-rangements', label:'Meubles de rangement', kinds:['storage','shelving','chest','shoe_storage','clothes_rack','towel_rack','bar_cart','tv_stand']},
    {handle:'bureaux', label:'Bureaux', kinds:['desk']},
    {handle:'chaises-de-bureau', label:'Chaises de bureau', kinds:['office_chair']},
    {handle:'jardin', label:'Meubles de Jardin', kinds:['garden_set','armchair','sofa','dining_chair','dining_table','coffee_table','side_table']},
    {handle:'chevets', label:'Tables de chevet', kinds:['bedside','side_table','chest']},
    {handle:'consoles', label:'Tables et consoles', kinds:['console']},
    {handle:'tabourets', label:'Tabourets & chaises de bar', kinds:['bar_stool']},
    {handle:'buffets', label:'Buffets', kinds:['sideboard']},
    {handle:'canapes', label:'Canapés et sofas', kinds:['sofa']},
    {handle:'chambre-enfants', label:'Meubles pour enfants', kinds:['kids_headboard','kids_table_set','kids_chair','kids_storage','kids_sofa','high_chair']},
    {handle:'decoration-pour-la-maison-livraison-gratuite-nordlys', label:'Décoration', kinds:['mirror','rug','cushion','basket','laundry_basket','pet_bed','wine_rack','table_lamp','floor_lamp','vase','tray']}
  ];
  const types = [
    ['pet_bed', /(?:panier|niche|lit).*(?:chat|chien)|pet bed/],
    ['laundry_basket', /panier.*linge|laundry/],
    ['basket', /paniers?|corbeille|basket/],
    ['wine_rack', /porte.?bouteilles?|wine rack/],
    ['high_chair', /chaise.*(?:bebe|haute pour)|high chair/],
    ['table_set', /ensemble.*table.*(?:chaises?|tabourets?)/],
    ['garden_set', /salon de jardin|outdoor set|garden set/],
    ['headboard', /tetes? de lit|headboard/],
    ['bedside', /chevet|bedside|nightstand/],
    ['office_chair', /(?:chaise|fauteuil)s?(?:\s+de)?\s+bureau|office chair/],
    ['bar_table', /tables? (?:de bar|hautes?)|bar table/],
    ['bar_stool', /(?:tabouret|chaise)s?.*(?:de bar|hauteur|hauts?)|bar stool/],
    ['pouf', /pouf|repose.pied|ottoman/],
    ['dining_chair', /chaise|fauteuil de table|dining chair/],
    ['console', /console/],
    ['coffee_table', /tables? basses?|tables?.*gigognes|coffee table/],
    ['side_table', /tables? (?:d.?\s*)?appoint|bout de canape|side table/],
    ['dining_table', /tables?.*(?:manger|repas|personnes|jardin)|dining table/],
    ['desk', /bureau|desk/],
    ['sofa', /canape|banquette|sofa/],
    ['bed', /\blits?\b|\bbed\b/],
    ['armchair', /fauteuil|armchair|rocking chair/],
    ['bench', /\bbancs?\b|bench/],
    ['stool', /tabouret|stool/],
    ['mirror', /miroir|mirror/],
    ['table_lamp', /lampe.*(?:poser|table)|table lamp/],
    ['floor_lamp', /lampadaire|floor lamp/],
    ['vase', /vase/],
    ['tray', /plateau decoratif|vide.poche|decorative tray/],
    ['cushion', /coussin|cushion/],
    ['rug', /tapis|\brug\b/],
    ['shoe_storage', /meuble.*chaussures|shoe/],
    ['clothes_rack', /vestiaire|portant|porte.?manteau/],
    ['towel_rack', /porte.?serviette/],
    ['bar_cart', /desserte|bar cart/],
    ['tv_stand', /meuble.*\btv\b|tv stand/],
    ['sideboard', /buffet|sideboard/],
    ['chest', /commode|chiffonnier|chest of drawers/],
    ['shelving', /etagere|bibliotheque|shelving|bookcase/],
    ['storage', /rangement|storage/]
  ];
  const relations = {
    dining_table:{dining_chair:94,bench:84,sideboard:80,wine_rack:78},
    dining_chair:{dining_table:94,sideboard:84,wine_rack:80,bar_cart:78},
    bar_table:{bar_stool:96,wine_rack:84,sideboard:80},
    bar_stool:{bar_table:96,wine_rack:86,sideboard:84,bar_cart:82},
    sofa:{coffee_table:92,side_table:88,pouf:84,cushion:88,rug:86,floor_lamp:80},
    armchair:{side_table:92,pouf:88,cushion:86,rug:84,floor_lamp:82},
    pouf:{side_table:88,armchair:84,rug:84,cushion:82},
    stool:{side_table:84,rug:86,basket:84},
    coffee_table:{side_table:86,rug:90,basket:80,armchair:80,vase:84,tray:84},
    side_table:{armchair:86,pouf:84,rug:86,basket:80,coffee_table:84,table_lamp:86,vase:80},
    console:{mirror:94,basket:88,rug:84,table_lamp:86,vase:84,tray:82},
    bed:{bedside:96,bench:86,rug:86,chest:80},
    headboard:{bedside:94,bench:84,rug:86},
    bedside:{rug:88,basket:84,table_lamp:90,mirror:80},
    desk:{office_chair:98,shelving:82,basket:78,table_lamp:88},
    office_chair:{desk:96,shelving:82},
    storage:{basket:92,mirror:84,bench:80},
    shelving:{basket:94,mirror:80,rug:80},
    chest:{mirror:92,basket:88,rug:84},
    sideboard:{wine_rack:94,mirror:90,basket:82,vase:86,table_lamp:84},
    tv_stand:{coffee_table:92,rug:88,side_table:84},
    clothes_rack:{bench:92,shoe_storage:88,mirror:88,basket:84,rug:84},
    shoe_storage:{mirror:92,clothes_rack:88,bench:86,rug:84},
    towel_rack:{laundry_basket:94,basket:88,rug:84},
    bar_cart:{wine_rack:94,sideboard:84},
    bench:{mirror:88,rug:86,basket:84,clothes_rack:82},
    mirror:{console:88,sideboard:84,basket:84},
    rug:{basket:90,cushion:88,pouf:80},
    cushion:{rug:92,basket:86,pouf:80},
    basket:{rug:90,cushion:86,shelving:80},
    laundry_basket:{towel_rack:94,basket:86,rug:84},
    pet_bed:{rug:90,basket:82},
    wine_rack:{sideboard:92,bar_cart:92,bar_table:88,console:82},
    table_lamp:{side_table:92,bedside:90,console:86},
    floor_lamp:{armchair:90,side_table:88,rug:84},
    vase:{console:88,sideboard:88,tray:82},
    tray:{coffee_table:88,console:88,vase:84},
    garden_set:{side_table:96},
    kids_table_set:{kids_storage:96,kids_sofa:84,rug:84,basket:82},
    kids_chair:{kids_storage:96,kids_sofa:84,rug:84,basket:82},
    kids_storage:{basket:94,rug:90,kids_chair:84,kids_sofa:82},
    kids_sofa:{kids_storage:94,rug:90,basket:84},
    kids_headboard:{kids_storage:92,rug:90,basket:84},
    high_chair:{kids_storage:88,basket:88,rug:84}
  };
  const words = (text, list) => list.filter(w => new RegExp('\\b' + w + '\\b').test(text));
  const familyOf = p => normalize((p.title || p.reference || '').split(/\s*[-–—]\s*/)[0]).replace(/\b(?:lot de \d+|\d+ chaises?)\b/g, '').trim();
  const numeric = v => Number(String(v || '').replace(',', '.')) || 0;
  function profile(p) {
    // Match with the original product information; display and sell in the visitor's language/market.
    if (p.canonical) {
      const {canonical, ...localized} = p;
      return {...profile({...localized, ...canonical}), title:p.title, reference:p.reference, description:p.description};
    }
    const title = normalize(p.title), reference = normalize(p.reference), collections = p.collections || [];
    const name = [title,reference].join(' ');
    // Prefer the precise product title. Descriptions describe other furniture and are not identity signals.
    const findType = text => types.find(([,rule]) => rule.test(text))?.[0];
    let kind = findType(title) || findType(reference) || '';
    if (!kind) {
      for (const [handle, fallback] of [['chaises-de-bureau','office_chair'],['bureaux','desk'],['buffets','sideboard'],['chevets','bedside'],['tabourets','bar_stool'],['chaises','dining_chair'],['fauteuils-1','armchair'],['consoles','console'],['canapes','sofa'],['tables-a-manger','dining_table'],['etageres-et-rangements','storage']]) {
        if (collections.includes(handle)) {kind=fallback;break;}
      }
    }
    const children = /enfants?|bebe|kids|children/.test(name) || collections.includes('chambre-enfants');
    if (children) kind = ({headboard:'kids_headboard',table_set:'kids_table_set',dining_table:'kids_table_set',dining_chair:'kids_chair',sofa:'kids_sofa',shelving:'kids_storage',storage:'kids_storage'})[kind] || kind;
    const descriptive = normalize([p.description,p.materials,p.wood,p.fabric,name].join(' '));
    // Keep range separators in technical specifications (e.g. an adjustable seat at 44-54 cm).
    const specs = String(p.description||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
    const dimensions = specs.match(/dimensions?\s+(?:du\s+)?produits?[^:=(]*?(?:\([^)]*\))?\s*[:=]\s*(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)(?:\s*[/–-]\s*\d+(?:[.,]\d+)?)?\s*cm/);
    const dim = dimensions ? dimensions.slice(1).map(numeric) : [];
    const flat = title.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*cm/);
    const seat = specs.match(/hauteur\s+(?:de\s+l.assise|d.assise|assise)\s*[:=]?\s*(\d+(?:[.,]\d+)?)(?:\s*[/–-]\s*(\d+(?:[.,]\d+)?))?\s*cm/);
    const arm = specs.match(/hauteur\s+(?:des?\s+)?accoudoirs?\s*[:=]?\s*(\d+(?:[.,]\d+)?)/);
    const worktop = specs.match(/hauteur\s+(?:du\s+)?(?:plateau|plan de travail)\s*[:=]?\s*(\d+(?:[.,]\d+)?)/);
    // Use the actual garden menu collection; the legacy collection also contains indoor entry furniture.
    const outdoor = /jardin|exterieur|outdoor|terrasse/.test(name) || collections.includes('jardin');
    const materials = normalize([p.materials,p.wood,p.fabric,name].join(' '));
    return {...p,kind,model:familyOf(p),outdoor,children,
      categories:categories.filter(c=>collections.includes(c.handle)).map(c=>c.handle),
      width:numeric(p.width)||dim[0]||(flat ? numeric(flat[1]) : 0), depth:dim[1]||(flat ? numeric(flat[2]) : 0),height:dim[2]||0,
      worktopHeight:worktop ? numeric(worktop[1]) : /mural|rabattable/.test(title) ? 0 : dim[2]||0,
      seat:seat ? numeric(seat[1]) : 0,seatMax:seat ? numeric(seat[2]||seat[1]) : 0,arm:arm ? numeric(arm[1]) : 0,
      styles:words(descriptive,['scandinave','boheme','industriel','contemporain','minimaliste','vintage','moderne']),
      materialsSet:words(materials,['pin','chene','noyer','hetre','frene','bois','rotin','cannage','metal','verre','marbre','velours','bouclette','tissu','ceramique','jute','coton','bambou','acacia']),
      colors:words(title+' '+reference,['beige','blanc','blanches','noir','gris','naturel','marron','terracotta','vert','bleu','rose','jaune','transparent']).map(c=>c==='blanches'?'blanc':c)
    };
  }
  function candidateHandles(rawCart) {
    const handles = new Set();
    for (const p of rawCart.map(profile)) {
      if (p.outdoor) {handles.add('jardin');continue;}
      const targets = Object.keys(relations[p.kind] || {});
      for (const c of categories) if (c.handle !== 'jardin' && c.kinds.some(k=>targets.includes(k))) handles.add(c.handle);
    }
    return [...handles];
  }
  function score(source,candidate,cart) {
    const base = relations[source.kind]?.[candidate.kind];
    if (!base || source.outdoor !== candidate.outdoor || !candidate.available || !candidate.image) return null;
    // Children may receive neutral decor, never adult-size desks, chairs or dining furniture.
    if (source.children !== candidate.children && !(source.children && ['rug','basket'].includes(candidate.kind))) return null;
    if (cart.some(p=>p.id===candidate.id || (p.kind===candidate.kind && p.model && p.model===candidate.model))) return null;
    if (cart.some(p=>p.kind===candidate.kind && p.outdoor===candidate.outdoor && p.children===candidate.children)) return null;
    if (source.kind==='dining_table' && ['dining_chair','bench'].includes(candidate.kind) && cart.some(p=>['dining_chair','bench'].includes(p.kind) && p.outdoor===source.outdoor && !p.children)) return null;
    // Check table/seat clearance in both directions, including adjustable office seats.
    const table = ['dining_table','bar_table','desk'].includes(source.kind) ? source : ['dining_table','bar_table','desk'].includes(candidate.kind) ? candidate : null;
    const chair = ['dining_chair','bar_stool','office_chair','bench'].includes(source.kind) ? source : ['dining_chair','bar_stool','office_chair','bench'].includes(candidate.kind) ? candidate : null;
    const tableHeight = table && (table.kind==='desk' ? table.worktopHeight : table.height);
    if (table && chair && tableHeight) {
      const low = chair.seat || (chair.kind==='bench' ? chair.height : 0), high = chair.seatMax || low;
      if (low && (tableHeight-high>34 || tableHeight-low<22)) return null;
      if (chair.arm && chair.arm>=tableHeight-3) return null;
    }
    if (candidate.kind==='pouf' && (candidate.height>52 || candidate.width>75 || candidate.depth>75)) return null;
    if (candidate.kind==='bench' && ['bed','headboard','dining_table'].includes(source.kind) && source.width && candidate.width && candidate.width>source.width-20) return null;
    if (source.kind==='console' && candidate.kind==='mirror' && source.width && candidate.width && candidate.width>source.width) return null;
    if (['vase','table_lamp','tray'].includes(candidate.kind) && source.depth && candidate.depth && candidate.depth>source.depth-4) return null;
    if (['coffee_table','side_table'].includes(source.kind) && candidate.kind==='vase' && candidate.height>40) return null;
    if (candidate.kind==='basket' && ['shelving','desk','bedside'].includes(source.kind) && source.depth && candidate.depth && candidate.depth>source.depth) return null;
    if (candidate.kind==='rug') {
      const size = Math.max(candidate.width,candidate.depth);
      if (['sofa','armchair','coffee_table','tv_stand'].includes(source.kind) && size && size<120) return null;
      if (source.children && size>180) return null;
    }
    const shared = (a,b) => a.some(x=>b.includes(x));
    let value=base;
    if (shared(source.styles,candidate.styles)) value+=12;
    if (shared(source.materialsSet,candidate.materialsSet)) value+=8;
    if (shared(source.colors,candidate.colors)) value+=6;
    else if (candidate.colors.some(c=>['beige','blanc','noir','gris','naturel','transparent'].includes(c))) value+=3;
    if (source.price>0 && candidate.price>0) {
      const ratio=candidate.price/source.price;
      if (ratio<=0.5) value+=8; else if (ratio<=1) value+=4; else if (ratio>2) value-=14;
    }
    return value>=76 ? {source,product:candidate,score:value} : null;
  }
  function recommend(rawCart,rawProducts,count=3) {
    const cart=rawCart.map(profile), products=rawProducts.map(profile);
    const pairs=products.flatMap(p=>cart.map(s=>score(s,p,cart)).filter(Boolean));
    const chosen=[],models=new Set(),usedSources=new Set();
    while (chosen.length<count) {
      const remaining=pairs.filter(p=>!models.has(p.product.model));
      remaining.sort((a,b)=>Number(usedSources.has(a.source.id))-Number(usedSources.has(b.source.id)) || b.score-a.score || a.product.id-b.product.id);
      if (!remaining.length) break;
      const best=remaining[0];chosen.push(best);models.add(best.product.model);usedSources.add(best.source.id);
    }
    return chosen;
  }
  function withCanonicalIdentity(localized, original) {
    if (!original || original.id !== localized.id) throw new Error('Missing original product');
    const canonical = {};
    for (const key of ['title','reference','description','materials','wood','fabric','width','collections']) canonical[key] = original[key];
    return {...localized, canonical};
  }
  const dictionary = {
    "fr": [
      "Pour compléter votre intérieur",
      "Une sélection pour accompagner les pièces de votre panier.",
      "Ajouter au panier",
      "Voir le produit",
      "Pour accompagner {name}",
      "Ajout en cours…",
      "Impossible d’ajouter cet article. Consultez sa fiche produit.",
      "Produits précédents",
      "Produits suivants"
    ],
    "en": [
      "Complete your home",
      "Selected to complement the pieces in your cart.",
      "Add to cart",
      "View product",
      "To go with {name}",
      "Adding…",
      "Unable to add this item. Please view the product page.",
      "Previous products",
      "Next products"
    ],
    "de": [
      "Ergänzen Sie Ihr Zuhause",
      "Passend zu den Artikeln in Ihrem Warenkorb ausgewählt.",
      "In den Warenkorb",
      "Produkt ansehen",
      "Passend zu {name}",
      "Wird hinzugefügt…",
      "Dieser Artikel konnte nicht hinzugefügt werden. Bitte öffnen Sie die Produktseite.",
      "Vorherige Produkte",
      "Nächste Produkte"
    ],
    "es": [
      "Completa tu hogar",
      "Una selección para complementar los artículos de tu carrito.",
      "Añadir al carrito",
      "Ver producto",
      "Para combinar con {name}",
      "Añadiendo…",
      "No se ha podido añadir el artículo. Consulta su ficha.",
      "Productos anteriores",
      "Productos siguientes"
    ],
    "it": [
      "Completa il tuo arredamento",
      "Una selezione da abbinare agli articoli nel carrello.",
      "Aggiungi al carrello",
      "Vedi prodotto",
      "Da abbinare a {name}",
      "Aggiunta in corso…",
      "Impossibile aggiungere questo articolo. Consulta la scheda prodotto.",
      "Prodotti precedenti",
      "Prodotti successivi"
    ],
    "nl": [
      "Maak je interieur compleet",
      "Geselecteerd als aanvulling op de artikelen in je winkelwagen.",
      "In winkelwagen",
      "Bekijk product",
      "Passend bij {name}",
      "Toevoegen…",
      "Dit artikel kon niet worden toegevoegd. Bekijk de productpagina.",
      "Vorige producten",
      "Volgende producten"
    ],
    "pt": [
      "Completa a tua casa",
      "Uma seleção para complementar os artigos do teu carrinho.",
      "Adicionar ao carrinho",
      "Ver produto",
      "Para combinar com {name}",
      "A adicionar…",
      "Não foi possível adicionar este artigo. Consulta a página do produto.",
      "Produtos anteriores",
      "Produtos seguintes"
    ],
    "pl": [
      "Uzupełnij swoje wnętrze",
      "Produkty dobrane do artykułów w Twoim koszyku.",
      "Dodaj do koszyka",
      "Zobacz produkt",
      "Pasuje do {name}",
      "Dodawanie…",
      "Nie udało się dodać produktu. Otwórz jego stronę.",
      "Poprzednie produkty",
      "Następne produkty"
    ],
    "da": [
      "Fuldend din indretning",
      "Udvalgt til at passe til varerne i din kurv.",
      "Læg i kurv",
      "Se produkt",
      "Passer til {name}",
      "Tilføjer…",
      "Varen kunne ikke tilføjes. Se produktsiden.",
      "Forrige produkter",
      "Næste produkter"
    ],
    "sv": [
      "Komplettera ditt hem",
      "Utvalt för att passa produkterna i din varukorg.",
      "Lägg i varukorgen",
      "Visa produkt",
      "Passar till {name}",
      "Lägger till…",
      "Produkten kunde inte läggas till. Öppna produktsidan.",
      "Föregående produkter",
      "Nästa produkter"
    ],
    "fi": [
      "Täydennä sisustuksesi",
      "Valittu täydentämään ostoskorisi tuotteita.",
      "Lisää ostoskoriin",
      "Katso tuote",
      "Sopii yhteen tuotteen {name} kanssa",
      "Lisätään…",
      "Tuotetta ei voitu lisätä. Avaa tuotesivu.",
      "Edelliset tuotteet",
      "Seuraavat tuotteet"
    ],
    "hu": [
      "Egészítsd ki otthonod berendezését",
      "A kosaradban lévő termékekhez válogatva.",
      "Kosárba",
      "Termék megtekintése",
      "Ehhez ajánljuk: {name}",
      "Hozzáadás…",
      "A terméket nem sikerült hozzáadni. Nyisd meg a termékoldalt.",
      "Előző termékek",
      "Következő termékek"
    ]
  };
  if (typeof module !== 'undefined' && module.exports) module.exports={profile,score,recommend,candidateHandles,categories,relations,withCanonicalIdentity,dictionary};
  if (typeof document === 'undefined') return;
  if (window.nlCartSuggestionsStarted) return;
  window.nlCartSuggestionsStarted = true;

  const cache = new Map();
  let revision = 0, timer, currentIds = '', busy = false, carouselObserver;
  const root = () => window.Shopify?.routes?.root || '/';
  const read = el => JSON.parse(el.textContent);
  async function getJson(url, signal) {
    const result = await fetch(url, {credentials: 'same-origin', signal});
    if (!result.ok) throw new Error('Request failed');
    return result.json();
  }
  const localeCode = locale => String(locale || document.documentElement.lang || 'fr').toLowerCase().split(/[-_]/)[0];
  const cleanRoot = value => '/' + String(value || '').replace(/^\/+|\/+$/g, '') + (String(value || '').replace(/^\/+|\/+$/g, '') ? '/' : '');
  function originalRoot(context) {
    const alternate = document.querySelector('link[rel="alternate"][hreflang="fr"]');
    if (alternate) {
      const url = new URL(alternate.href, location.origin);
      if (url.origin === location.origin && /\/cart\/?$/.test(url.pathname)) return cleanRoot(url.pathname.replace(/cart\/?$/, ''));
    }
    return cleanRoot(context.languageRoots?.fr);
  }
  async function cartContext(context, localeRoot) {
    const url = new URL(localeRoot + 'cart', location.origin);
    url.searchParams.set('section_id', context.section);
    const response = await fetch(url, {credentials:'same-origin', signal:AbortSignal.timeout(15000)});
    if (!response.ok) throw new Error('Cart context unavailable');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const node = doc.querySelector('[data-nl-complements-context]');
    if (!node) throw new Error('Cart context missing');
    return read(node);
  }
  async function loadCollection(handle, localeRoot = root()) {
    const key = localeRoot + handle;
    if (cache.has(key)) return cache.get(key);
    const job = (async () => {
      let page = 1, pages = 1, products = [];
      do {
        const url = new URL(localeRoot + 'collections/' + handle, location.origin);
        url.searchParams.set('view', 'nl-complements'); url.searchParams.set('page', String(page));
        const data = await getJson(url, AbortSignal.timeout(15000));
        if (!Array.isArray(data.products) || !Number.isInteger(data.pages)) throw new Error('Invalid catalog');
        pages = data.pages; products.push(...data.products); page++;
      } while (page <= pages);
      return products;
    })();
    cache.set(key, job);
    job.catch(() => cache.delete(key));
    return job;
  }
  function element(tag, text, className) {
    const el = document.createElement(tag); if (text) el.textContent = text; if (className) el.className = className; return el;
  }
  function report(name, data) {
    // Custom events use Shopify's existing pixel/consent infrastructure.
    try { window.Shopify?.analytics?.publish?.(name, data); } catch (_) { /* optional analytics */ }
  }
  function render(host, results, context) {
    carouselObserver?.disconnect();
    const t = dictionary[localeCode(context.locale)] || dictionary.en;
    const arrowLabels = t.slice(7, 9);
    const heading = element('h2', t[0], 'nl-complements__heading'); heading.id = 'nl-complements-heading';
    const header = element('div', '', 'nl-complements__header');
    const navigation = element('div', '', 'nl-complements__navigation');
    const arrows = arrowLabels.map((label, index) => {
      const button = element('button', '', 'nl-complements__arrow nl-complements__arrow--' + (index ? 'next' : 'previous'));
      button.type = 'button'; button.setAttribute('aria-label', label); button.setAttribute('aria-controls', 'nl-complements-products');
      const icon = element('span'); icon.setAttribute('aria-hidden', 'true'); button.append(icon); navigation.append(button); return button;
    });
    header.append(heading, navigation);
    const intro = element('p', t[1], 'nl-complements__intro');
    const list = element('div', '', 'nl-complements__grid'); list.id = 'nl-complements-products';
    for (const pair of results) {
      const p = pair.product, article = element('article', '', 'nl-complements__card');
      const link = element('a', '', 'nl-complements__image'); link.href = p.url;
      const image = element('img'); image.src = p.image; image.alt = p.title; image.width = 360; image.height = 360; image.loading = 'lazy'; link.append(image);
      const name = element('h3'); const title = element('a', p.title); title.href = p.url; title.title = p.title; name.append(title);
      const model = (pair.source.title || pair.source.reference).split(/\s+[-–—]\s+/)[0];
      const reason = element('p', t[4].replace('{name}', model), 'nl-complements__reason');
      const price = element('p', p.priceText, 'nl-complements__price');
      const status = element('p', '', 'nl-complements__status'); status.setAttribute('role', 'status');
      article.append(link, reason, name, price);
      if (p.variantCount === 1 && p.variant && !p.sellingPlanRequired) {
        const button = element('button', t[2], 'nl-complements__add'); button.type = 'button';
        button.addEventListener('click', async () => {
          if (busy) return; busy = true; button.disabled = true; button.textContent = t[5];
          try {
            // Recheck cart at click time, including items added in another tab.
            const cart = await getJson(root() + 'cart.js', AbortSignal.timeout(12000));
            if (cart.items.some(i => i.product_id === p.id)) { location.reload(); return; }
            const result = await fetch(root() + 'cart/add.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({items: [{id: p.variant, quantity: p.minimum || 1, properties: {_nl_suggestion: 'cart-v2', _nl_source_product: String(pair.source.id)}}]})});
            if (!result.ok) throw new Error('Cart rejected item');
            report('nl_cart_suggestion_added', {product_id: p.id, source_product_id: pair.source.id});
            // Native page reload preserves theme discounts, notes, totals and inventory validation.
            location.reload();
          } catch (_) {
            status.textContent = t[6]; const fallback = element('a', t[3]); fallback.href = p.url; status.append(' ', fallback);
            button.disabled = false; button.textContent = t[2]; busy = false;
          }
        });
        article.append(button);
      } else {
        const view = element('a', t[3], 'nl-complements__add'); view.href = p.url; article.append(view);
      }
      article.append(status); list.append(article);
    }
    host.replaceChildren(header, intro, list); host.hidden = results.length === 0;
    const updateArrows = () => {
      const maximum = list.scrollWidth - list.clientWidth;
      navigation.hidden = maximum <= 2;
      arrows[0].disabled = list.scrollLeft <= 2;
      arrows[1].disabled = list.scrollLeft >= maximum - 2;
    };
    arrows.forEach((button, index) => button.addEventListener('click', () => {
      const step = list.firstElementChild?.getBoundingClientRect().width + (parseFloat(getComputedStyle(list).columnGap) || 0);
      list.scrollBy({left: (index ? 1 : -1) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }));
    list.addEventListener('scroll', updateArrows, {passive: true});
    carouselObserver = new ResizeObserver(updateArrows); carouselObserver.observe(list);
    requestAnimationFrame(updateArrows);
    if (results.length) report('nl_cart_suggestions_viewed', {product_ids: results.map(r => r.product.id), rule_version: 'v2'});
  }
  async function update(refreshContext = false) {
    const run = ++revision;
    let host = document.querySelector('[data-nl-complements]');
    let dataNode = document.querySelector('[data-nl-complements-context]');
    if (!host || !dataNode) return;
    host.hidden = true;
    try {
      let context = read(dataNode);
      if (refreshContext) {
        // Market/currency cookies can change in another tab before an AJAX cart update.
        cache.clear();
        const url = new URL(root() + 'cart', location.origin); url.searchParams.set('section_id', context.section);
        const response = await fetch(url, {credentials: 'same-origin', signal: AbortSignal.timeout(12000)});
        if (!response.ok) throw new Error('Cart refresh failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = doc.querySelector('[data-nl-complements-context]');
        if (!fresh) return; context = read(fresh);
      }
      if (!context.products.length) return;
      const canonicalRoot = localeCode(context.locale) === 'fr' ? root() : originalRoot(context);
      const needsOriginal = localeCode(context.locale) !== 'fr';
      let cartProducts = context.products;
      if (needsOriginal) {
        const original = await cartContext(context, canonicalRoot);
        if (localeCode(original.locale) !== 'fr') throw new Error('Original language unavailable');
        const originals = new Map(original.products.map(p => [p.id, p]));
        cartProducts = context.products.map(p => withCanonicalIdentity(p, originals.get(p.id)));
      }
      const handles = candidateHandles(cartProducts);
      // At most three requests at once; paginate every selected collection fully.
      const candidates = [];
      for (let i = 0; i < handles.length; i += 3) {
        const settled = await Promise.allSettled(handles.slice(i, i + 3).map(async handle => {
          const localized = await loadCollection(handle);
          if (!needsOriginal) return localized;
          const originals = new Map((await loadCollection(handle, canonicalRoot)).map(p => [p.id, p]));
          return localized.filter(p => originals.has(p.id)).map(p => withCanonicalIdentity(p, originals.get(p.id)));
        }));
        settled.forEach(r => { if (r.status === 'fulfilled') candidates.push(...r.value); });
      }
      if (run !== revision) return;
      const unique = [...new Map(candidates.map(p => [p.id, p])).values()];
      host = document.querySelector('[data-nl-complements]'); if (!host) return;
      render(host, recommend(cartProducts, unique), context);
    } catch (_) { /* Leave the block hidden; checkout continues normally. */ }
  }
  function cartSignature() {
    const list = document.querySelector('[data-cart-items]');
    return list ? [...list.querySelectorAll('input')].map(el => el.id + ':' + el.value).join('|') : '';
  }
  currentIds = cartSignature();
  const observer = new MutationObserver(records => {
    if (records.every(r => r.target.closest?.('[data-nl-complements]'))) return;
    const next = cartSignature();
    if (next === currentIds) return;
    currentIds = next; clearTimeout(timer); timer = setTimeout(() => update(true), 450);
  });
  const main = document.querySelector('#MainContent'); if (main) observer.observe(main, {childList: true, subtree: true});
  document.addEventListener('shopify:section:load', () => update());
  update();
})();
